console.log("Welcome To SoleConnect.net");


jQuery(".productSlider").slick({
    "dots": true,
    "infinite": true,

    "mobileFirst": true,
    "autoplay": true,
    "autoplaySpeed": 15000,
    "slidesToShow": 2,
    "slidesToScroll": 2,
    "centerMode": false,
    "nextArrow": '<button class="slick-next"><i class="fas fa-arrow-right " ></i></button>',
    "prevArrow": '<button class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
    "arrows": true,
    "responsive": [
        {
            "breakpoint": 992,
            "settings": {
                "dots": true,
                "slidesToShow": 5,
                "slidesToScroll": 5,
                "centerMode": false
            }
        },
        {
            "breakpoint": 768,
            "settings": {
                "dots": true,
                "slidesToScroll": 4,
                "slidesToShow": 4,
                "centerMode": false

            }
        },
        {
            "breakpoint": 480,
            "settings": {
                "slidesToScroll": 3,
                "dots": false,
                "slidesToShow": 3

            }
        }
    ]
});



// jQuery(".brands_slider").slick({
//     "dots": true,
//     "infinite": true,

//     "mobileFirst": true,
//     "autoplay": true,
//     "autoplaySpeed": 15000,
//     "slidesToShow": 2,
//     "slidesToScroll": 2,
//     "centerMode": false,
//     "nextArrow": '<button class="slick-next"><i class="fas fa-arrow-right " ></i></button>',
//     "prevArrow": '<button class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
//     "arrows": true,
//     "responsive": [
//         {
//             "breakpoint": 768,
//             "settings": {
//                 "dots": true,
//                 "slidesToScroll": 5,
//                 "slidesToShow": 5,
//                 "centerMode": false

//             }
//         },
//         {
//             "breakpoint": 480,
//             "settings": {
//                 "slidesToScroll": 3,
//                 "dots": false,
//                 "slidesToShow": 3

//             }
//         }
//     ]
// });


// jQuery('video').click(function(e){

//     var vid = document.getElementById(e.target.id);
//     vid.currentTime = 0;
//     vid.play();

// })

jQuery(function () {
    // var options = jQuery('.bc-product-form__control');
    // options.each(function () {
    //     var label = jQuery(this).find(".inputLabel");
    //     label.each(function () {
    //         var sizeMap = jQuery(this).find(".bc-product-variant__label--rectangle").text().trim();
    //         var regex = /^(\d*\.*\d*)/g;

    //         var toReplace = sizeMap.match(regex);
    //         jQuery(this).data("size", toReplace);
    //     })

    //     var numericallyOrderedLabels = label.sort(function (a, b) {

    //         return jQuery(a).data("size") - jQuery(b).data("size");
    //     });
    //     jQuery(this).find(".bc-product-form__option-variants--inline").append(numericallyOrderedLabels);
    // });
});
